import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css'
import {useLazyResetPasswordQuery} from "../services/endpoints/user.api";
const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const [showSuccess, setShowSuccess] = useState(false);

    const [triggerResetPassword,{ isLoading, isSuccess } ]= useLazyResetPasswordQuery();
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await triggerResetPassword({ email }).unwrap();

            // Se arriva qui, il backend ha risposto con 200
            console.log("Successo:", res);
            setShowSuccess(true);
        } catch (error) {
            console.error("Errore durante il reset password:", error);
            alert("Errore durante l'invio della richiesta.");
        }
    };

    return (
        <div>
            <Header/>
            <main className="container form-signin w-50 pt-5 m-sm-auto text-center">
                <form onSubmit={handleSubmit}>
                    <div className="form-floating mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <label>Inserisci la mail per il reset password</label>
                    </div>
                    <button className="btn btn-primary w-100 py-2" type="submit" disabled={isLoading}>
                        {isLoading ? "Invio..." : "Conferma"}
                    </button>

                    {showSuccess && (
                        <div className="alert alert-success mt-3">
                            Email reset inviata con successo!
                        </div>
                    )}
                </form>
            </main>
            <Footer />
        </div>
    );

};

export default ResetPassword;
